// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"1d51bbbf","23":"b3c347d8","80":"874b5b0d","194":"3fe7ed07","436":"5a0b29e5","481":"031c8506","488":"7e116942","581":"93efc87a","720":"1d1648be","789":"5c3132ab","850":"ee5a498d","946":"18675dbe"}[chunkId] + ".chunk.js";
};